import type {FC} from 'react';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Box, Stack} from '@wellstone-solutions/web';
import {Hooks} from '@wellstone-solutions/common';
import {Resource} from '@wellstone-solutions/common/models/rest';
import type {UIResourceType} from '@wellstone-solutions/common/models/rest';
import {useStores} from 'hooks/useStores';
import {PageHeader} from 'components/PageHeader';
import {ALERT_TYPES, showAlert} from 'utils/showAlert';
import {
  ActionButtons,
  ResourceForm,
  resourceSchema,
  showSavedAlert,
} from '../ResourceForm';

const FORM_ID = 'new_resource_form';

export const NewResource: FC = () => {
  const {appUIStore, resourceStoreV2} = useStores();
  const navigate = useNavigate();

  useEffect(() => {
    appUIStore.setBreadcrumbs([]);
  }, [appUIStore]);

  useEffect(() => {
    resourceStoreV2.getCollections();
  }, [resourceStoreV2]);

  const form = Hooks.useForm({
    initialValues: Resource.Factory(),
    schema: resourceSchema,
    validationEngine: 'yup',
    onSubmit: async (values: UIResourceType) => {
      const response = await resourceStoreV2.createResource(values);

      if (response.isSuccess) {
        showSavedAlert(response.data?.validation ?? null);
        navigate('/resources');
      } else {
        showAlert('Failed to save resource', ALERT_TYPES.ERROR);
      }
    },
  });

  return (
    <Box>
      <Stack direction="column" sx={{mb: 4}}>
        <PageHeader
          title="Create Resource"
          description="All fields are optional unless indicated as required."
          backButtonProps={{label: 'Back to Resources', path: '/resources'}}
        />

        <ResourceForm form={form} formId={FORM_ID} />

        <ActionButtons form={form} formId={FORM_ID} />
      </Stack>
    </Box>
  );
};
